import React, { useState, useEffect, useRef } from "react";
import { TIME_SELECTION, APPOINTMENT_FORM } from "/components/estate-calendar/components/Calendar";

export default props => {
    useEffect( () => {
        const input = document.getElementById("form-input-calendarId");
        input.value = props.appointmentId;
    });

    const dayNames = {
        0: "zondag",
        1: "maandag",
        2: "dinsdag",
        3: "woensdag",
        4: "donderdag",
        5: "vrijdag",
        6: "zaterdag",
    };

    const monthNames = {
        0: 'januari',
        1: 'februari',
        2: 'maart',
        3: 'april',
        4: 'mei',
        5: 'juni',
        6: 'juli',
        7: 'augustus',
        8: 'september',
        9: 'oktober',
        10: 'november',
        11: 'december',
    };

    return (
        <>
            <div className="calendar__title-container">
                <h2 className="calendar__title">Boek een afspraak</h2>
                <button
                    className="calendar__back-button"
                    onClick={ () => props.setSelectedPane(TIME_SELECTION) }
                >
                    {"< "}Kies een ander tijdstip
                </button>
            </div>
            <h3 className="calendar__summary">
                U koos voor een afspraak op{" "}
                <strong>{ props.appointmentDate.getDate().toString().slice(-2) } { monthNames[props.appointmentDate.getMonth()] }</strong>{" "}
                om{" "}
                <strong>
                    {("0" + props.startTime.getHours()).slice(-2)}:{("0" + props.startTime.getMinutes()).slice(-2)}
                </strong>
            </h3>
            <div
                className="calendar__form"
                dangerouslySetInnerHTML={{ __html: window.appointmentForm }}
            ></div>
        </>
    );
};
